import {getContrast} from 'utils/common/color';
import {theme} from 'config/themes';

import type {Store, Actions} from 'store/slices/app/types';

export function activate(state: Store, action: Actions['Activate']) {
  const {active} = action.payload;
  state.active = active;
}

export function load(state: Store, action: Actions['Load']) {
  const {loaded} = action.payload;
  state.loaded = loaded;
}

export function login(state: Store, action: Actions['Login']) {
  let {header} = action.payload;
  // Limit too light of a primary color
  if (header.custom && getContrast(header.colors.primary) === 'black')
    header.colors.primary = theme.app.logo;
  // Update user
  state.user = action.payload;
  // TODO: Move below to menu ref in Main
  // Empty trial account logged in, show menu by default
  // if (state.user.group === Actions['UserGroup.Trial
  //  && state.user.limit.storage.used === 0)
}

export function logout(state: Store) {
  state.user = null;
}

export function updateNotifications(state: Store, action: Actions['Notify']) {
  state.notifications = action.payload.count;
}
